import { useEffect } from 'react'

import axios from '@/utils/assessmentAxiosInterceptor'

export const loadInitial = (dispatch) => {
    useEffect(() => {
        const getData = async () => {
            try {
                // Send a request to the server to pass back information regarding this current case
                let { data: body } = await axios.get(`/assessment/api/dashboard/loadInitialDashboard`)

                if (!body.success) {
                    window.location = '/login'
                    return
                }

                dispatch({ type: 'SET_USER', payload: body.data.user })
                dispatch({ type: 'SET_COMPANIES', payload: body.data.companies })
                dispatch({ type: 'SET_PARTNERSHIPS', payload: body.data.partnerships })
                dispatch({ type: 'SET_LOADED' })
            } catch (e) {
                if (e?.response?.status === 401) {
                    window.location = '/login'
                    return
                }
                console.log(e)
                return
            }
        }

        getData()
    }, [])
}
